import React from 'react';
import { newToastMessageAsync } from '@Containers/ToastMessages/ToastMessagesActions';
import CopiedToastMessage from '@Containers/ToastMessages/CopiedToastMessage/CopiedToastMessage';

// eslint-disable-next-line import/prefer-default-export
export const showCopiedToastMessage = (message) =>
  newToastMessageAsync({
    id: 'full-text-success-toast',
    // eslint-disable-next-line react/jsx-filename-extension
    title: <CopiedToastMessage message={message} />,
    className: 'els-toast-message full-text-success-toast-message',
    closeBtn: true,
  });
